import {
  ButtonBase,
  Checkbox,
  IconButton as MuiIconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  Typography,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useState } from 'react'

import CustomControl from '@/components/map/custom-control'

import { useStyles } from './styles'

interface VisualizationStates {
  perimeters: boolean
  mosaic: boolean
  map: boolean
}

interface VisualizationButtonProps {
  states: VisualizationStates
  onShowChange: (
    type: 'perimeters' | 'mosaic' | 'map',
    checked: boolean,
  ) => void
}

export function VisualizationControlButton({
  states,
  onShowChange,
}: VisualizationButtonProps) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <CustomControl style={{ overflow: 'hidden' }} position='bottomright'>
        <ButtonBase
          className={classes.root}
          aria-label={'Alterar visualização'}
          onClick={handleOpen}
        >
          <span className='material-symbols-outlined'>map</span>
        </ButtonBase>
      </CustomControl>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 28,
          horizontal: 29,
        }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        classes={{ paper: classes.popoverPaper }}
        elevation={1}
      >
        <div className={classes.popoverHeader}>
          <Typography variant='h6'>Selecione o que deseja ver</Typography>
          <MuiIconButton
            aria-label='close'
            className={classes.closeButton}
            size='small'
            onClick={handleClose}
          >
            <CloseIcon />
          </MuiIconButton>
        </div>
        <List classes={{ root: classes.list }} disablePadding dense>
          <ListItem
            button
            onClick={() => onShowChange('perimeters', !states.perimeters)}
          >
            <ListItemIcon>
              <Checkbox
                edge='start'
                checked={states.perimeters}
                tabIndex={-1}
                disableRipple
                color='secondary'
                inputProps={{ 'aria-labelledby': 'check-box-perimeter-label' }}
              />
            </ListItemIcon>
            <ListItemText
              primary='Perímetros do diagnóstico'
              id='check-box-perimeter-label'
            />
          </ListItem>
          <ListItem
            button
            onClick={() => onShowChange('mosaic', !states.mosaic)}
          >
            <ListItemIcon>
              <Checkbox
                edge='start'
                checked={states.mosaic}
                tabIndex={-1}
                disableRipple
                color='secondary'
                inputProps={{ 'aria-labelledby': 'check-box-mosaic-label' }}
              />
            </ListItemIcon>
            <ListItemText primary='Ortomosaico' id='check-box-mosaic-label' />
          </ListItem>
          <ListItem button onClick={() => onShowChange('map', !states.map)}>
            <ListItemIcon>
              <Checkbox
                edge='start'
                checked={states.map}
                tabIndex={-1}
                disableRipple
                color='secondary'
                inputProps={{ 'aria-labelledby': 'check-box-map-label' }}
              />
            </ListItemIcon>
            <ListItemText primary='Mapa satélite' id='check-box-map-label' />
          </ListItem>
        </List>
      </Popover>
    </>
  )
}
